// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DIre","content":"styles_content__1MZw4","row":"styles_row__1vYwV","footer":"styles_footer__3CkSU","phraseLength":"styles_phraseLength__2BzvT"};